import Vue from 'vue'
import App from './App.vue'
import Func from './Func.vue'
Vue.mixin(Func);
import ArtworkDefaultImages from './ArtworkDefaultImages.vue'
Vue.mixin(ArtworkDefaultImages);

import VueRouter from 'vue-router'
import router from './router'
Vue.use(VueRouter)

import './../node_modules/bulma/css/bulma.css';
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import Axios from 'axios';
Vue.prototype.Axios = Axios;
Vue.prototype.secret = "0499BBxxCv";

const PRODUCTION = true;
if (PRODUCTION) {
  Vue.prototype.idiom = "https://admin.idiomtalent.com/";
  Vue.prototype.api = "https://api.idiomtalent.com/?/";
  // Vue.prototype.idiom = "http://66.29.138.193/idiomtalent/admin/";
  // Vue.prototype.api = "https://idiomtalent.com/fetch/?/";
} else {
  Vue.prototype.idiom = "http://localhost:8000/admin_idiomtalent/";
  Vue.prototype.api = "http://localhost:8000/idiomtalent_app/api/";
}


import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '',
  loading: 'logo/lazy.png',
  attempt: 1
})

import VueLazyLoadVideo from 'vue-lazyload-video'
Vue.use(VueLazyLoadVideo)

import VueAgile from 'vue-agile'
Vue.use(VueAgile)

import VueSwal from 'vue-swal'
Vue.use(VueSwal)

// import AudioVisual from 'vue-audio-visual'
// Vue.use(AudioVisual)
// import VueAudio from 'vue-audio-better'
// Vue.use(VueAudio)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
